// Client testimonials. Order supplied by the client; industry drives placement.
export const TESTIMONIALS = [
  {
    name: "Pritpaul Singh", city: "Ludhiana", industry: "Machinery",
    quote: "We needed CNC and packaging machinery from China and had been burned once before. The Atlas team verified the factory, sat in on our video audit and negotiated the price down. The machines landed exactly as promised.",
  },
  {
    name: "Ankit", city: "New Delhi", industry: "Machinery",
    quote: "Sourced a full line of food-processing machinery through them. Their landed-cost breakdown was spot on — no surprises at customs, and the pre-shipment inspection caught two issues before the balance went out.",
  },
  {
    name: "Ashish", city: "Bangalore", industry: "Fasteners",
    quote: "They really understood our fastener drawings — grades, coatings, PPAP — and the plant they used was IATF-certified. The first container of bolts passed incoming QC one hundred percent.",
  },
  {
    name: "Jaskaran Singh", city: "Hyderabad", industry: "Textile",
    quote: "They mapped the right knitwear cluster for us and handled sampling and QC end to end. Our reorders now ship on time, every time.",
  },
  {
    name: "Smaksh", city: "Chandigarh", industry: "Fabric",
    quote: "Needed specialty fabric at a price that worked. The Atlas found two mills, ran the audit and consolidated the shipment. Saved us nearly twenty percent versus our old supplier.",
  },
  {
    name: "Lisa", city: "Germany", industry: "Furniture",
    quote: "We diversified our furniture sourcing to Vietnam with their China+1 desk. Verified partners, clean documentation and inspections we could trust from Europe.",
  },
  {
    name: "Giulia", city: "Italy", industry: "Lighting",
    quote: "Importing lighting from China felt risky until we worked with them. Every supplier was vetted, and the pre-shipment AQL inspection gave us total confidence.",
  },
];
